<template>
  <div class="comment-wrap">
    <div v-for="item in prop" :key="item.id">
      <div>
        <div>
          <span>{{item.userName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.createTime}}</span>
        </div>
        <div>
          {{item.contentSource}}
        </div>
      </div>
      <div>
        <Common v-if="item.children && item.children.length != 0" :prop="item.children"></Common>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Common",
  props: {
    prop: Array
  },
  methods: {
    reply(id,name){
      this.$emit('reply',id,name)
    },
     //评论点赞
    getZanEval(e,pid) {
      this.$http
        .get("api/core/005-userZanPc", {
          params: {
            token: this.$store.state.userInfo.token,
            type: 5,
            thirdId: pid
          }
        })
        .then(res => {
          console.log(res, "评论点赞");
          $(e.target).toggleClass('active')
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.comment-wrap{background:#eee;margin-top:15px;}
.comment-wrap{
  &>div{
    &>div:nth-child(1){
      &>div:nth-child(1){
        font-size: 14px;
        display: flex;
        line-height: 36px;
        justify-content: space-between;
        padding:0px 10px;
        &>span:nth-child(2){
          font-size: 12px;
          color:#999;
          i{
            font-size:12px;
            color:#999;
            margin-right: 15px;
          }
        }
      }
      &>div:nth-child(2){
        font-size: 14px;
        display: flex;
        color: #999;
        padding:0px 10px 8px;
      }
    }
  }
}
.comment-wrap{
  &>div{
    &>div:nth-child(1){
      &>div:nth-child(1){
        &>span:nth-child(2){
          i.active{
            color:#0a8228
          }
        }
      }
      &>div:nth-child(2){

      }
    }
  }
}
</style>


